/**
 * The "new supported" draft: filling a supported's details in in the Nedarim Plus personal area,
 * where a coordinator can type every detail in front of them but cannot attach the certificates
 * the record needs, and finishing it here.
 *
 * ⚠️ There is no flag of its own. It rides the one key that governs every Nedarim draft - see
 * NEDARIM_DRAFTS_FEATURE_KEY for why the two kinds are deliberately not released apart.
 */
export { default, NEDARIM_DRAFTS_FEATURE_KEY } from '@/pages/SupportRequests/Drafts/useSupportRequestDraftsFeature';

/** The draft kind stored on the row - see DraftKinds on the server. */
export const SUPPORTED_DRAFT_KIND = 'Supported';
